import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateClassStreamService=async(data)=>{
    try {
        const result = await post(`api/admin/class_stream/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClassStreamService=async(data,id)=>{
    try {
        const result = await put(`api/admin/class_stream/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassStreamService=async()=>{
    try {
        const result = await get(`api/admin/class_stream/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClassStreamService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/class_stream/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

